var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-transporte"},[_c('v-container',{staticClass:"d-flex align-center justify-center",attrs:{"fluid":""}},[_c('Login')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }